import { useEffect, useState } from 'react';

import axiosInstance from 'src/utils/axios';

import { IInventoryBatch } from 'src/types/inventory-batch';

// Group-agnostic — the backend route is shared between kitchen and bar.
// Fetches active (quantity > 0) batches for an item, FEFO-sorted, whenever
// itemId changes. Pass null/undefined to skip fetching (e.g. no item
// selected yet, or the line is a RETURN which doesn't need batches).
export function useItemBatches(itemId: string | null | undefined) {
  const [batches, setBatches] = useState<IInventoryBatch[]>([]);
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'failure'>('idle');

  useEffect(() => {
    if (!itemId) {
      setBatches([]);
      setStatus('idle');
      return undefined;
    }

    let cancelled = false;
    setStatus('loading');

    axiosInstance
      .get(`inventory/item/${itemId}/batches?activeOnly=true`)
      .then((response) => {
        if (!cancelled) {
          setBatches(response.data.data);
          setStatus('success');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStatus('failure');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [itemId]);

  return { batches, status };
}
